module.exports = __webpack_public_path__ + "static/img/11.405ed58.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/11.jpg
// module id = 282
// module chunks = 0